<template>
  <div ref="modal-locator" class="orion-modal-locator"><slot></slot></div>
</template>
<script setup lang="ts">
import { provide, useTemplateRef } from 'vue'
import { modalLocatorContextKey } from './types'

defineOptions({ name: 'OModalLocator', inheritAttrs: true })
const locator = useTemplateRef('modal-locator')

provide(modalLocatorContextKey, {
  locator,
})
</script>
<style lang="scss" scoped>
.orion-modal-locator {
  width: 100%;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  position: relative;

  :deep(> .el-overlay) {
    position: absolute;

    > .el-overlay-dialog {
      position: absolute;
    }
  }
}
</style>
